import API from "./api";

// Admin Login
export const adminLogin = async (data) => {
    try {
        const response = await API.post("/admin/login", data);

        return response.data;
    } catch (error) {
        throw error.response?.data || {
            message: "Something went wrong",
        };
    }
};

// Admin Profile
export const getAdminProfile = async () => {
    try {
        const response = await API.get("/admin/profile");

        return response.data;
    } catch (error) {
        throw error.response?.data || {
            message: "Failed to fetch profile",
        };
    }
};

export const getDashboardAnalytics = async () => {
    try {
        const response = await API.get("/admin/dashboard-analytics");

        return response.data;
    } catch (error) {
        throw (
            error.response?.data || {
                message: "Failed to fetch dashboard data"
            }
        );
    }
};